<template>
  <div>
    <v-container fluid>
      <v-form>
        <v-row>
          <v-col>
            <v-autocomplete
              name="plans"
              :menu-props="{ contentClass: 'text-left benefits' }"
              dense
              :label="$t('globals.plan')"
              v-model="plan"
              :items="plans"
              :item-text="planDescription"
              item-value="Id"
              hide-details
              clearable
              return-object
              :rules="[$rules.required]"
              class="required"
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      sortBy="Name"
      :exporters="$exporters"
      @error="error = $event"
    ></pbas-data-table>

    <drug-edit
      :drug="editdrug"
      @cancel="editdrug = null"
      @update:drug="
        editdrug = null;
        $refs.table.getDataAsync();
      "
    ></drug-edit>
    <deactivate-drug-dialog
      :drug="selected"
      @cancel="
        selected = [];
        deactivateDrugDialog = false;
      "
      @saved="
        selected = [];
        deactivateDrugDialog = false;
        $refs.table.getDataAsync();
      "
      :model="deactivateDrugDialog"
    ></deactivate-drug-dialog>
    <v-dialog v-model="showImport" max-width="700" scrollable>
      <drug-import
        v-if="showImport"
        @cancel="showImport = false"
        @upload="
          showImport = false;
          $refs.table.getDataAsync();
        "
        :provider="$refs.table"
        :planId="plan.Id"
      />
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmDeleteDialog"
      persistent
      max-width="400"
    >
      <material-card
        :title="
          $t('components.new_drugs.drugs_table.delete_{0}_drugs', [
            selected.length,
          ])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="confirmDeleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error" />
  </div>
</template>

<script>
import DrugHeaders from "../../headers/NewDrugs";
import { ODataProvider } from "pbas-vue-components";
import { mapActions, mapGetters } from "vuex";
import DrugEdit from "./DrugEdit";
import DrugImport from "./DrugImport";
import ErrorHandler from "../../components/ErrorHandler";
import { translate2 } from "@/trans2";
import DeactivateDrugDialog from "./DeactivateDrugDialog.vue";

export default {
  props:["brokerId"],
  components: {
    DrugEdit,
    ErrorHandler,
    DrugImport,
    DeactivateDrugDialog,
  },
  data: function() {
    return {
      editdrug: null,
      provider: undefined,
      headers: DrugHeaders,
      error: null,
      showImport: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.edit(item),
          visible: (item) =>
            item.DeactivatedAt === null || item.DeactivatedAt === undefined,
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.deactivate",
          handler: (item) => {
            this.selected = item;
            this.deactivateDrugDialog = true;
          },
          visible: (item) =>
            item.DeactivatedAt === null || item.DeactivatedAt === undefined,
        },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.edit({ Din: null, Name: "", PlanId: this.plan.Id });
          },
        },
        {
          name: "import",
          icon: "cloud_upload",
          color: this.$vuetify.theme.themes.light.primary,
          text: "globals.import",
          handler: () => {
            this.showImport = true;
          },
        },
      ],
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (items) => {
            this.selected = items;
            this.confirmDeleteDialog = true;
          },
        },
      ],
      plan: null,
      confirmDeleteDialog: false,
      selected: [],
      deactivateDrugDialog: false,
    };
  },
  computed: {
    ...mapGetters("common", ["plans", "settings"]),
  },
  mounted() {
    this.loadUserPlans();
  },
  watch: {
    plan: {
      handler(v) {
        if (v) {
          this.provider = undefined;
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", ["deleteDrugs"]),
    ...mapActions("auth", ["login", "silentRefresh"]),
    ...mapActions("plansMembers", ["getUserPlans"]),
    ...mapActions("common", ["setPlans"]),
    planDescription(plan) {
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
    async loadUserPlans() {
      try {
        var usr = await this.silentRefresh();
        if (usr) {
          let plans = (await this.getUserPlans()).data.value;
          this.setPlans(
            plans.filter(o=>o.BrokerId === this.brokerId).map((o) => {
              o.Name = o.Current.Name;
              o.Description = o.Current.Description;
              o.Translations = o.Current.Translations;
              return o;
            })
          );
        }
      } catch (error) {
        //console.log("selectPlan: silent refresh error: ", error);
        this.login();
      }
    },
    edit(item) {
      this.editdrug = item;
    },
    loadPlanData() {
      // if (this.provider === undefined) {
      this.provider = new ODataProvider(
        this.$axiosHttp,
        `${this.settings.APIURL}plans/${this.plan.Id}/drugs-formulary`,
        this.headers
      );
      // } else {
      //   this.$refs.table.getDataAsync();
      // }
    },
    async tryDelete() {
      try {
        await this.deleteDrugs({
          payload: this.selected.map((o) => o.Id),
        });
        this.confirmDeleteDialog = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
